export type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
export const PIXEL_ID = '1106774291706659';
export function trackInitiateCheckout() {
  window.fbq?.('track', 'InitiateCheckout');
}
